import { Injectable } from '@angular/core';

export type LocalItem =
  | 'QR_CODE'
  // Separate key from `QR_CODE`: a bi-product beneficiary must not have one product's offline QR overwrite the other's.
  | 'QR_CODE_PRUNEO'
  // Optimistic cache only: the onboarding status source of truth is a server flag (see `ProductOnboardingService`).
  | 'PRODUCT_ONBOARDING_STATUS'
  | 'PRODUCT_CONTEXT'
;

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {

  get(key: LocalItem): any {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  }

  set(key: LocalItem, value: any): void {
    localStorage.setItem(key, JSON.stringify(value));
  }

  remove(key: LocalItem): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
